import React, { Component } from 'react'
import PropTypes from 'prop-types'

const buildDynamicFieldsRegex = (dynamicFields) => (
  new RegExp(`\{\{(${dynamicFields.join('|')})\}\}`, 'g')
)

export default class TextBlockPreview extends Component {
  static propTypes = {
    html: PropTypes.string,
    dynamicFields: PropTypes.object,
    processDynamicFields: PropTypes.func,
    processResults: PropTypes.func
  }

  static defaultProps = {
    processDynamicFields: (name, value) => value,
    processResults: x => x
  }

  processHtml() {
    const { html='', dynamicFields={}, processDynamicFields, processResults } = this.props
    const dynamicFieldNames = Object.keys(dynamicFields)
    const regex = buildDynamicFieldsRegex(dynamicFieldNames)
    
    let processedHtml = html
    
    while (regex.test(processedHtml)) {
      regex.lastIndex = 0
      
      processedHtml = processedHtml.replace(regex, (match, field) => {
        if (field === 'email_signature_image' && dynamicFields[field]) {
          return `<div class="signature-logo"><img src="${dynamicFields[field]}" alt="Email Signature" style="width:120px; height:auto;" /></div>`
        }
        return processDynamicFields(field, dynamicFields[field])
      })
      
      regex.lastIndex = 0
    }
    
    const __html = processResults(processedHtml)
    return { __html }
  }

  render() {
    return (
      <div
        className="text-block-preview"
        dangerouslySetInnerHTML={this.processHtml()} />
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/TextBlockPreview.js